import React from "react"
import { TransferApplicationStatus } from "../types"

interface StatusBadgeProps {
  status: TransferApplicationStatus
}

export const StatusLabels: Record<TransferApplicationStatus, string> = {
  in_progress: "入稿前",
  applied: "入稿登録済",
  completed: "送金確認済",
  cancelled: "キャンセル",
  matching_error: "照合エラー",
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const getStatusStyles = (status: TransferApplicationStatus): string => {
    switch (status) {
      case "in_progress":
        return "bg-gray-100 text-gray-800 border border-gray-300"
      case "applied":
        return "bg-blue-100 text-blue-800 border border-blue-300"
      case "completed":
        return "bg-green-100 text-green-800 border border-green-300"
      case "matching_error":
        return "bg-red-100 text-red-800 border border-red-300"
      default:
        return "bg-gray-100 text-gray-800 border border-gray-300"
    }
  }

  return (
    <div
      className={`inline-flex items-center justify-center rounded px-2 py-1 text-2xl font-normal ${getStatusStyles(
        status
      )}`}
    >
      {StatusLabels[status]}
    </div>
  )
}

export default StatusBadge
